import { FreelancerInfoPanelClickTypes } from '../typings/freelancers';
import { ClientFreelancerData } from '../typings/state';

export const REQUEST_CLIENT_FREELANCER_DATA = 'REQUEST_CLIENT_FREELANCER_DATA';
export type REQUEST_CLIENT_FREELANCER_DATA = typeof REQUEST_CLIENT_FREELANCER_DATA;

export const UPDATE_CLIENT_FREELANCER_DATA = 'UPDATE_CLIENT_FREELANCER_DATA';
export type UPDATE_CLIENT_FREELANCER_DATA = typeof UPDATE_CLIENT_FREELANCER_DATA;

export const FREELANCER_INFO_PANEL_CLICKED = 'FREELANCER_INFO_PANEL_CLICKED';
export type FREELANCER_INFO_PANEL_CLICKED = typeof FREELANCER_INFO_PANEL_CLICKED;

export interface RequestClientFreelancerDataAction {
    type: REQUEST_CLIENT_FREELANCER_DATA;
}

export interface UpdateClientFreelancerDataAction {
    type: UPDATE_CLIENT_FREELANCER_DATA;
    data?: ClientFreelancerData;
}

export interface FreelancerInfoPanelClickedAction {
    type: FREELANCER_INFO_PANEL_CLICKED;
    clickType: FreelancerInfoPanelClickTypes;
}

export function requestClientFreelancerData(): RequestClientFreelancerDataAction {
    return {
        type: REQUEST_CLIENT_FREELANCER_DATA
    };
}

export function updateClientFreelancerData(data?: ClientFreelancerData): UpdateClientFreelancerDataAction {
    return {
        type: UPDATE_CLIENT_FREELANCER_DATA,
        data
    };
}

export function freelancerInfoPanelClicked(clickType: FreelancerInfoPanelClickTypes): FreelancerInfoPanelClickedAction {
    return {
        type: FREELANCER_INFO_PANEL_CLICKED,
        clickType
    };
}

export type ClientFreelancerDataAction =
    | RequestClientFreelancerDataAction
    | UpdateClientFreelancerDataAction
    | FreelancerInfoPanelClickedAction;
